/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/21/2019.
 */

import React from 'react';
import {injectIntl} from 'react-intl';
import momentTz from 'moment-timezone'

/**
 * This component does not render anything. It provides access to internationalization
 * for classes which are not a React components
 */
class LocaleHelper extends React.Component {
    static instance = null;

    componentWillMount() {
        if (!LocaleHelper.instance) {
            LocaleHelper.instance = this;
        }
    }

    render() {
        return false;
    }
}

export default injectIntl(LocaleHelper);

export const intl = () => {
    return LocaleHelper.instance.props.intl;
}

export const formatMessage = (...args) => {
    return intl().formatMessage(...args);
}

export const formatDateTime = (date) => {
    if (!date) {
        return null
    }
    const localDate = momentTz.tz(date, 'UTC').toDate()
    return intl().formatDate(localDate) + ' ' + intl().formatTime(localDate)
}